import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ss-login" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "ss-login-logo",
  src: "/static/img/ss-logo.png",
  alt: "NeoX - Sabre Sistemas"
}, null, -1)
const _hoisted_5 = { class: "ss-login-dados-autenticacao" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "ss-login-label" }, "E-mail", -1)
const _hoisted_9 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_10 = { class: "ant-input-group-addon" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "ss-login-label" }, "Senha", -1)
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-12" }, null, -1)
const _hoisted_16 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-12",
  style: {"text-align":"right"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "ss-login-consultor" }, [
  /*#__PURE__*/_createTextVNode("Necessita de ajuda?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://atendimento.sabresistemas.com.br/"
  }, "Fale com nosso suporte técnico.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_icone = _resolveComponent("icone")!
  const _component_campo_senha = _resolveComponent("campo-senha")!
  const _component_quadro_login = _resolveComponent("quadro-login")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.state.mensagemAlerta)
            ? (_openBlock(), _createBlock(_component_a_alert, {
                key: 0,
                message: _ctx.state.mensagemAlerta,
                banner: ""
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_icone, {
                    class: "ss-icone",
                    nome: "usuario-preenchido"
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "ant-input",
                  style: {"text-align":"left"},
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.dadosLogin.login) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.efetuarLogin && _ctx.efetuarLogin(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.state.dadosLogin.login]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_campo_senha, {
                valor: _ctx.state.dadosLogin.senha,
                "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.dadosLogin.senha) = $event)),
                onKeyEnter: _ctx.efetuarLogin
              }, null, 8, ["valor", "onKeyEnter"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.redefinirSenha && _ctx.redefinirSenha(...args)))
              }, "Esqueci minha senha")
            ])
          ]),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.efetuarLogin && _ctx.efetuarLogin(...args))),
            class: "ss-login-btn"
          }, "Acessar"),
          _hoisted_17
        ])
      ]),
      _createVNode(_component_quadro_login)
    ])
  ]))
}